import { useQuestionBuilder } from 'lib-node-question-builder';

import useIsWriteAccessDisabled from '~/common/hooks/useIsWriteAccessDisabled';
import useUrl from '~/common/hooks/useUrl';
import Loan1003FormContainer from '~/pages/Loan1003DataGrids/common/components/Loan1003FormContainer';
import Loan1003FormSection from '~/pages/Loan1003DataGrids/common/components/Loan1003FormSection';

import { READONLY_CONDITION } from '../constants';
import {
  useGetAssetsSummaryInformationQuery,
  useUpdateAdditionalReservesMutation,
} from '../hooks';
import { useAsset1003Store } from '../store';

export function ReservesForm() {
  const { data } = useGetAssetsSummaryInformationQuery();

  const { isLoading, mutate } = useUpdateAdditionalReservesMutation();

  const { isReadOnly } = useUrl();

  const isWriteAccessDisabled = useIsWriteAccessDisabled() || isReadOnly;

  const { form, handleSubmit } = useQuestionBuilder({
    formData: {
      additionalReserves: data?.assetsSummaryInformation.additionalReserves,
      comments: data?.reservesComment,
    },
    screenData: {
      isWriteAccessDisabled,
    },
    hooks: {
      onSubmit: (values) => {
        mutate({
          additionalReserves: values.additionalReserves,
          reservesComment: values.comments,
          productType: data?.loanProductType,
        });
      },
    },
  });

  return (
    <form.Provider>
      <Loan1003FormContainer
        isLoading={isLoading || !data}
        readOnlyMode={isWriteAccessDisabled}
        onSaveClicked={() => {
          handleSubmit();
        }}
        onCloseClicked={() => {
          useAsset1003Store.setState({ activeForm: null });
        }}
      >
        <Loan1003FormSection title="Reserve Information">
          <form.Currency
            name="additionalReserves"
            label="Additional Reserves"
            placeholder="Additional Reserve"
            hasBottomBorder={false}
            rules={{
              required: true,
            }}
            conditions={{
              isDisabled: READONLY_CONDITION,
            }}
          />
        </Loan1003FormSection>
        <Loan1003FormSection title="Loan Information">
          <form.Grid
            name="loan information comments grid"
            columns={4}
            style={{ padding: '0 0 0 1rem' }}
          >
            <form.GridItem colSpan={4}>
              <form.TextArea
                name="comments"
                label="Comments"
                placeholder="Comments"
                minRows={3}
                hasBottomBorder={false}
                conditions={{
                  isDisabled: READONLY_CONDITION,
                }}
              />
            </form.GridItem>
          </form.Grid>
        </Loan1003FormSection>
      </Loan1003FormContainer>
    </form.Provider>
  );
}
